export enum SalesforceRecordTypes {
  Account = 'Account',
  Case = 'Case',
  Contact = 'Contact',
  Lead = 'Lead',
  Opportunity = 'Opportunity',
  User = 'User',
}

export const getSalesforceRecordURL = ({
  instanceURL,
  recordID,
  recordType,
}: {
  instanceURL: string;
  recordID: string;
  recordType: SalesforceRecordTypes;
}) => {
  return `${instanceURL}/lightning/r/${recordType}/${recordID}/view`;
};
